module.exports = __webpack_public_path__ + "img/Media-Twitter.4a9cbfde.svg";